module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00022-fs8.3f03fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00022-fs8.png
// module id = 175
// module chunks = 0